import styled from 'styled-components';

export const ListStyles = styled.ul`
  padding: 0;
  list-style-position: inside;
  list-style-type: ${({ listStyleType }) => listStyleType || 'unset'};
`;
